
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[touristicContent]",
      function () {
        return require("private-next-pages/service/[touristicContent].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[touristicContent]"])
      });
    }
  